module.exports = __webpack_public_path__ + "img/857.aac8942b.gif";